import { useSearchParams } from 'react-router-dom';

import { useFilteredTemplatesListQuery, WaypointTemplateType } from '@dashboard/generated/wp/platform';

export default function useCurrentTemplatesQuery() {
  const [params] = useSearchParams();
  return useFilteredTemplatesListQuery({
    fetchPolicy: 'network-only',
    variables: {
      type: getQueryType(params),
      page: getPage(params),
    },
  });
}

function getPage(params: URLSearchParams): number | undefined {
  const page = params.get('page');
  if (page === null) {
    return undefined;
  }
  return parseInt(page, 10);
}

function getQueryType(params: URLSearchParams): WaypointTemplateType {
  const type = params.get('type');
  if (type === 'LAYOUT') {
    return WaypointTemplateType.Layout;
  }
  return WaypointTemplateType.Template;
}
